import type { ReactNode } from 'react'

// Cartao de uma secao do formulario de produto (spec 2026-09-30): faixa clara
// com icone e titulo, campos embaixo.
export default function Secao({ icone, titulo, children }: { icone: ReactNode; titulo: string; children: ReactNode }) {
  return (
    <section className="bg-white rounded-xl shadow-sm p-4 space-y-3">
      <h3 className="flex items-center gap-2 bg-teal-50 text-teal-900 rounded-lg px-3 py-2 font-semibold">
        <span className="text-teal-800">{icone}</span>{titulo}
      </h3>
      {children}
    </section>
  )
}
